// removed by extract-text-webpack-plugin
module.exports = {"button":"DownloadButton__button__1Juq-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/controls/DownloadButton.scss
// module id = 682
// module chunks = 0